import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'
import { FcMenuService } from '../fc-menu/fc-menu.service'

@Component({
    selector: 'fc-menu-option',
    templateUrl: './fc-menu-option.component.html',
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        CommonModule,
        MatTooltipModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FcMenuOptionComponent {
  @Output()
  private readonly clickEvent = new EventEmitter<void>()

  @Input({ required: true })
  public icon!: string

  @Input({ required: false })
  public tooltipText: string = ''

  @Input({ required: true })
  public text!: string

  @Input()
  public isFirst = false

  @Input()
  public isLast = false

  @Input()
  public disabled = false

  private readonly fcMenuService = inject(FcMenuService)

  public clickOption(): void {
    if (this.disabled) {
      return
    }

    this.clickEvent.emit()
    this.fcMenuService.close$.next()
  }
}
